import Policies from './authorization-policies';
import store from '@/store';
import { invoke, isObject, castArray, get } from 'lodash';

var AuthorizationManager = {
	get roles() {
		return castArray(get(store.getters, 'oidcStore/oidcUser.role', []));
	},
	get permissions() {
		return castArray(
			get((store.getters || store.default.getters), 'oidcStore/oidcUser.SupportPermission', [])
		);
	},
	get policies() {
		return Policies;
	},
	validate(authorization) {
		if (isObject(authorization)) {
			const rolesCheck =
				authorization.roles?.every(role => this.roles.includes(role)) ??
				true;
			const permissionsCheck =
				authorization.permissions?.every(permission =>
					this.permissions.includes(permission)
				) ?? true;
			const policiesCheck =
				authorization.policies?.every(policy =>
					invoke(this.policies, policy)
				) ?? true;

			return rolesCheck && permissionsCheck && policiesCheck;
		}

		return true;
	}
};

export default AuthorizationManager;
